import React, { Component } from "react";

export default function HOC(HOCComp, data) {
  return class extends Component {
    constructor(props) {
      super(props);
      this.state = {
        data: data,
      };
    }
    render() {
      return <HOCComp data={this.state.data} {...this.props} />;
    }
  };
}
